import { createListViewContainer } from 'factories/ListView'
import selectors from 'selectors'
import actions from 'actions/reports/transactionAuditReport'
import Component from 'components/Reports/TransactionAuditReport'

export default createListViewContainer({ actions, selectors: selectors.transactionAuditReport })(Component)
